// apps/client/src/characters/remote.ts — another resident in your space, drawn ~100 ms behind server time (§4.7, §8.3 netInterp)
import type { CatalogId, MoveState, ResidentId, Vec2 } from '@whiskerton/shared';
import * as THREE from 'three';
import { InterpBuffer } from '../net/interp';
import type { Avatar } from './avatar';

export class RemoteResident {
  readonly r: ResidentId;
  readonly avatar: Avatar;
  readonly buffer = new InterpBuffer<MoveState>();
  pos = new THREE.Vector3();
  /** The latest sample's tool; the Game's netInterp system loads it into the avatar's hand when it changes (null in M0). */
  lastTool: CatalogId | null = null;
  private placed = false;
  constructor(r: ResidentId, avatar: Avatar) { this.r = r; this.avatar = avatar; }
  /** renderAt = synced clock − tuning.net.interpDelayMs. Speed for the walk cycle = distance moved this frame / dt. */
  update(renderAt: number, dt: number, heightAt: (p: Vec2) => number): void {
    const s = this.buffer.sample(renderAt);
    if (!s) return;
    const moved = this.placed ? Math.hypot(s.x - this.pos.x, s.y - this.pos.z) : 0;
    this.pos.set(s.x, heightAt({ x: s.x, y: s.y }), s.y);
    this.placed = true;
    this.sync(s.f);
    this.avatar.setMove(s.a, dt > 0 ? moved / dt : 0);
    this.lastTool = s.tool;
  }
  /** Places at once (space.enter, a resync, a fresh spawn) and drops older samples. */
  snap(s: MoveState, heightAt: (p: Vec2) => number): void {
    this.buffer.clear();
    this.pos.set(s.x, heightAt({ x: s.x, y: s.y }), s.y);
    this.placed = true;
    this.sync(s.f);
    this.avatar.setMove(s.a, 0);
    this.lastTool = s.tool;
  }
  private sync(f: number): void {
    this.avatar.root.position.copy(this.pos);
    this.avatar.root.rotation.y = f;
  }
}
